import { AttachIcon, DeclineIcon } from '@synergy/theme';
import { List, ListItem, ListItemIcon, ListItemText, Stack, styled } from '@mui/material';
import { PoolIconButton, PoolLineClampTypography, PoolRow, PoolTypography } from '@synergy/components-next';
import { ReactElement } from 'react';

const FileList = styled(List)(({ theme }) => ({
    padding: 0,
    width: '100%',
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: 4,
}));

const StyledListItem = styled(ListItem)(({ theme }) => ({
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(1.5),
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    '&:last-child': {
        border: 'none',
    },
}));

export interface SingleInquiryFileListProps {
    fileNames: string[];
    onDelete?: (fileName: string) => void;
}

export const SingleInquiryFileList = (props: SingleInquiryFileListProps): ReactElement | null => {
    if (props.fileNames.length === 0) {
        return null;
    }

    return (
        <Stack gap={1} alignItems="start">
            <PoolTypography variant="caption" color="grey.500" translationId="app.singleInquiry.appendedFiles" />
            <FileList>
                {props.fileNames.map(fileName => (
                    <StyledListItem key={fileName}>
                        <ListItemIcon>
                            <AttachIcon />
                        </ListItemIcon>
                        <ListItemText>
                            <PoolRow spacing={0} justifyContent="space-between">
                                <PoolLineClampTypography>{fileName}</PoolLineClampTypography>
                                <PoolIconButton color="primary" onClick={() => props.onDelete?.(fileName)}>
                                    <DeclineIcon fontSize="medium" />
                                </PoolIconButton>
                            </PoolRow>
                        </ListItemText>
                    </StyledListItem>
                ))}
            </FileList>
        </Stack>
    );
};
